/** @jsxImportSource @emotion/react */

import { useRef, memo } from "react";

import { Box, Typography, Popper, PopperPlacementType } from "@material-ui/core";

import Button, { Props as ButtonProps } from "../Button";

import { paper, box, titleText, contentText, contentTextWithBtn, button } from "./styles";

export interface Action extends ButtonProps {
  label: string;
  primary?: boolean;
}
export interface Props {
  id: string;
  open: boolean;
  anchorEl: HTMLElement | Element | null;
  placement?: PopperPlacementType;
  title: string;
  content: string;
  actions?: Action[];
  [k: string]: any;
}

const Popover = ({
  id,
  open,
  anchorEl,
  placement = "bottom-end",
  title,
  content,
  actions = [],
  ...others
}: Props): JSX.Element => {
  const arrowRef = useRef<HTMLDivElement | null>(null);

  return (
    <Popper
      id={id}
      open={open}
      anchorEl={anchorEl}
      placement={placement}
      css={paper}
      modifiers={{
        flip: {
          enabled: false,
        },
        arrow: {
          enabled: true,
          element: arrowRef.current,
        },
      }}
      {...others}
    >
      <div className="arrow" ref={arrowRef} />
      <Box css={box}>
        <Typography css={titleText}>{title}</Typography>
        <Typography css={[contentText, actions && contentTextWithBtn]}>{content}</Typography>
        {actions?.map(({ primary, color = "primary", label, ...rest }, i) => (
          <Button
            // eslint-disable-next-line react/no-array-index-key
            key={`btn-${i}`}
            css={button}
            variant={primary || color === "error" ? "contained" : "outlined"}
            color={color}
            {...rest}
          >
            {label}
          </Button>
        ))}
      </Box>
    </Popper>
  );
};

export default memo(Popover);
